import { defineComponent } from 'vue'

import { TWO_DAYS_MS } from '~/utils/DateDisplay'

import type Submission from '~/types/submission'
import type SubmissionStatus from '~/types/submissionStatus'

/**
 * @deprecated use helpers/submission/status.ts
 */
export default defineComponent({
  data() {
    return {} as { submission: Submission }
  },
  computed: {
    /**
     * @deprecated use helpers/submission/status.ts
     */
    isComplexFn(): boolean {
      if (this.submission.status_history?.length)
        return (
          this.submission.status_history.includes('Wa') ||
          this.submission.status_history.includes('Wc')
        )
      else return false
    },
    /**
     * @deprecated use helpers/submission/status.ts
     */
    isUrgent(): boolean {
      if (this.submission.status !== 'Se') return false

      const threshold = TWO_DAYS_MS
      const now = new Date().getTime()

      return new Date(this.submission.expiry_date).getTime() <= now + threshold
    },
    /**
     * @deprecated use helpers/submission/status.ts
     */
    hasLastStatus(): boolean {
      return typeof this.lastStatus !== 'undefined'
    },
    /**
     * @deprecated use helpers/submission/status.ts
     */
    lastStatus(): SubmissionStatus {
      if (this.submission.status_history)
        for (let i = this.submission.status_history.length - 1; i >= 0; i--) {
          const status = this.submission.status_history[i]

          if (status !== this.submission.status) return status
        }

      return this.submission.status
    },
  },
})
